<template>
    <div class="container-fluid listings">
        <vue-headful
            :title="`Brokers Real Estate`"
        />
        <Search v-bind:search="search" v-bind:total="total"/>
        
        <div v-if="loading" class="loading text-center">
            <v-progress-linear :size="90" :width="7" color="#bc2025" indeterminate></v-progress-linear>
        </div>
        
        <v-container fluid class="px-3">
          
        <!-- <v-pagination
          class="pt-3"
        v-model="page"
        :length="numberOfPages"
        total-visible=8
        >
        </v-pagination> -->
            <v-data-iterator
                :items="listings"
                :items-per-page.sync="itemsPerPage"
                :page.sync="page"
                :search="search"
                :sort-by="sortBy.toLowerCase()"
                :sort-desc="sortDesc"
                
                hide-default-footer
                :loading="loading"

            >   
            <template v-slot:header>
        
      </template>
                 <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="listing in props.items"
            :key="listing.ListingKey"
            cols="12"
            sm="6"
            md="4"
            lg="4"
          >
            <v-card
             height="550"
             class="card-outter"
            >
              
              

                <div class="pt-2">
                  <h4 class="float-left px-3">${{ formatPrice(listing.ListPrice) }}</h4>
                  <div class="text-right px-3" style="margin-top:{-3rem; !important}">
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Active'">
                    <span class="badge badge-pill badge-success">For Sale</span>
                  </h4>
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Pending'">
                    <span class="badge badge-pill badge-warning">Pending</span>
                  </h4>
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Pending - Taking Backups'">
                    <span class="badge badge-pill badge-warning">Pending - Taking Backup Offers</span>
                  </h4>        
                  <h4 class="text-h4" v-if="listing.MlsStatus == 'Active Under Contract'">
                    <span class="badge badge-pill badge-warning">Pending - Under Contract</span>
                  </h4>
                  </div> 
                  <h5 class="float-right border-top px-3 pt-1"> {{listing.StreetNumber}} {{ listing.StreetName }}, {{listing.City}}</h5>
                  <div class="text-left border-top px-3 pb-2" >
                      <span v-if="listing.BedroomsTotal != null"><strong>Beds {{ listing.BedroomsTotal }} </strong></span>
                      <span v-else><strong>Beds -</strong></span>
                      <br>
                      <span v-if="listing.BathroomsTotalInteger != null"><strong>Baths {{ listing.BathroomsTotalInteger }} </strong></span>
                      <span v-else><strong>Baths -</strong></span>
                      <br>
                      <span v-if="listing.LivingArea != null"><strong> {{ listing.LivingArea }} Sq.Ft.</strong></span>
                      <span v-else><strong>{{listing.LotSizeAcres}} Acres</strong></span>
                  </div>
                </div>      
              <v-img
                  v-if="listing.PhotosCount"
                  max-height="250px"
                  v-bind:src="listing.Media[0].MediaURL"
              >
              </v-img>
              <v-img 
                v-else
                max-height="250px"
                src="../assets/nophoto.jpg"
                alt="no image"
                contain
              >
              </v-img>
    
              <div class="container card-actions mx-auto">
                <div class="align-text-bottom"><p>Listed By: {{listing.ListAgentFullName}} - {{listing.ListOfficeName}}</p></div>
                <div class="row">
                  <div class="col-sm border-top border-right">
                    <v-btn :to="{ path: 'property', query: { mlsid: listing.ListingId }}" block large dark color="#515352">View Property</v-btn>
                  </div>
                  <!-- <div class="col-sm border-top"> Property('a425784137554b6f5109b8b6510256ba')
                    <button class="btn btn-primary btn-lg btn-block">Contact Us</button>
                  </div> -->   
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
             <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span
            class="mr-4
            grey--text"
          >
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="ml-1"
            @click="nextPage"
          >
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template>
            </v-data-iterator>
        </v-container>
       <v-footer
      fixed
      class="font-weight-medium"
    >
      <v-col
        class="text-center"
        cols="12"
      >
       <v-pagination
          class="pt-1"
        v-model="page"
        :length="numberOfPages"
        total-visible=8
        >
        </v-pagination>
      </v-col>
    </v-footer>
    </div>
</template>

<script>
    import Search from '../components/Search';
    import Axios from 'axios';
    export default {
        name: "Listings",
        data() {
            return {
                listings: [],
                query: this.$route.query.param,
                accessURL: "https://api.bridgedataoutput.com/api/v2/actris/listings?access_token=c03d8edc2e18155f1d8d782866904cfa",
                limit:this.$route.query.limit,
                offset:null,
                API: '',
                loading: true,
                page: 1,
                pageCount: 0,
                total: '',
                itemsPerPageArray:[5,10,15,20,25], 
                itemsPerPage: 10,
                sortBy:"ListPrice",
                order: "desc",
                search: this.$route.query.City,
               



            }
        },
        components:{
            Search: Search
        },
        created(){
            if(this.$route.query.ListOfficeMlsId){
               console.log(this.$route.query) 
               this.API = this.accessURL+"&ListOfficeMlsId="+this.$route.query.ListOfficeMlsId
            }else if(this.$route.query.City){
              
              
              if(this.$route.query.maxBeds){
                   if(this.$route.query.maxBaths){
                     this.API = this.accessURL+"&City="+this.$route.query.City+"&BedroomsTotal.gte="+this.$route.query.maxBeds+"&BathroomsTotalInterger.gte"+this.$route.query.maxBaths
                   console.log(this.API)
                   }else{
                     this.API = this.accessURL+"&City="+this.$route.query.City+"&BedroomsTotal.gte="+this.$route.query.maxBeds
                    console.log(this.API)
                   }
              }else{
                this.API = this.accessURL+"&City="+this.$route.query.City
              console.log(this.API)
              }
            }else {
              console.log(this.$route.query)
              this.API = this.accessURL
            }
            
            Axios
            .get(this.API+"&limit="+this.limit+"&sortBy="+this.sortBy+"&order="+this.order)
            .then(response => {
                console.log(response)
                this.listings = response.data.bundle
                this.total = response.data.total
                console.log(this.total)
                console.log(this.listings)
                Object.keys(this.listings).forEach(keys =>{
                    if(this.listings[keys].PhotosCount > 0){
                        console.log(this.listings[keys].Media)
                    }
                })
            })
            .catch(error => {
                console.log(error)
                this.errored = true
            })
            .finally(() => this.loading = false)
        },
        computed: {
            numberOfPages () {
                return Math.ceil(this.listings.length / this.itemsPerPage)
            },
            
        },
        methods: {
            formatPrice(value) {
                let val = (value/1).toFixed(0).replace(',', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            nextPage () {
              if (this.page + 1 <= this.numberOfPages) this.page += 1
            },
            formerPage () {
              if (this.page - 1 >= 1) this.page -= 1
            },
            updateItemsPerPage (number) {
              this.itemsPerPage = number
            }
        },
           

    }
</script>

<style scoped>
.listings{
    margin-top: 80px;
}
</style>